import React from 'react';
import { Button, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';

const ActEditUser = ({ userInfo, setUserInfo, setOpenEdit }) => {
  const handleEdit = () => {
    setUserInfo(userInfo);
    setOpenEdit(true);
  };

  return (
    <Tooltip title="Chỉnh sửa người dùng">
      <Button
        type="primary"
        icon={<EditOutlined />}
        size="small"
        onClick={handleEdit}
        style={{
          marginRight: 8,
          backgroundColor: '#1890ff',
          borderColor: '#1890ff'
        }}
      />
    </Tooltip>
  );
};

export default ActEditUser;
